import { AuthProvider, AuthOptions } from "./authProviderInterface";
import MicrosoftAuth from "./microsoftAuth";

export interface MsalAuthOptions extends AuthOptions {
    msalConfig: any;
    authProviderType?: string;
}

export class MsalAuthProvider implements AuthProvider {
    install(Vue: any, options: MsalAuthOptions): void {
        MicrosoftAuth.install(Vue, {
            serverUrl: options.serverUrl,
            msalConfig: options.msalConfig,
            authProviderType: options.authProviderType
        });
        this.setupInterceptors();
    }

    async getToken(): Promise<string | undefined> {
        return await MicrosoftAuth.getToken();
    }

    logout(): void {
        MicrosoftAuth.logout();
    }

    logoutRedirect(postLogoutRedirectUri?: string): void {
        void MicrosoftAuth.logoutRedirect(postLogoutRedirectUri).catch((err) =>
            console.error("MSAL redirect sign-out failed.", err));
    }

    async signOutEmbedded(): Promise<void> {
        // Clears only this frame's MSAL session; Microsoft's own session and the user's standalone
        // tabs stay signed in. Reload only once it is gone: reloading with it intact would just sign
        // back in.
        await MicrosoftAuth.signOutLocally();
        window.location.reload();
    }

    setupInterceptors(): void {
        // Interceptors are set up in MicrosoftAuth.install
    }
}